import EventEmitter from "../../utils/eventEmitter";
import Axios from "../../utils/axios";


export const loadGroups = async () => {
  try {
    const response = await Axios.get('groups');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};



export const loadGroup = async (action) => {
  try {
    switch (action) {
      case 'new':
        // const response = await Axios.get('groups/setup');
        // const requestData = await response.data;
        // return {...requestData, group: {}};
        return { group: {} };
        
      default:
        const respnse = await Axios.get('groups/find/'+action);
        const responseData = await respnse.data;
        return responseData;
    }
  }catch (err) {
    throw err;
  }
}

const useGroupsAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('groups', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('groups', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('groups/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('groups', seo);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useGroupsAPI;


